import Immutable from 'seamless-immutable'

const styleguide = {
  grid: {
    tiny: 4,
    small: 8,
    appendix: 12,
    medium: 16,
    large: 24,
    xLarge: 32,
    xxLarge: 40,
  },
  padding: {
    xXSmall: 3,
    xSmall: 5,
    small: 10,
    medium: 15,
    large: 20,
    xLarge: 30,
  },
  color: {
    black: '#363434',
    extraLightGrey: '#f9f7f6',
    darkGreen: '#308F59',
    green: '#49b975',
    lightGreen: '#66cc91',
    grey: '#cfcdcc',
    lightGrey: '#f1efee',
    mediumGrey: '#8b8988',
    gray67: '#787776',
    gray50: '#9A9999',
    gray30: '#c2c2c1',
    gray25: '#cdcccc',
    gray16: '#DFDEDE',
    gray15: '#E1E1E1',
    gray8: '#efefef',
    gray4: '#f7f7f7',
    gray2: '#696766',
    darkGrey: '#585655',
    lightRed: 'rgba(245, 120, 129, 0.1)',
    red: '#ef404f',
    white: '#ffffff',
    blue: '#4182c3',
    orange: '#f27c00',
    darkMint: '#49b975',
    overlay: 'rgba(0, 0, 0, 0.4)', // For modals
    darkerOverlay: 'rgba(0, 0, 0, 0.8)', // For modals
    inputWarningOrange: 'rgba(242, 124, 0, 0.04)', // for input warning
  },
  font: {
    size: {
      xXLarge: 28,
      xLarge: 24,
      larger: 22,
      large: 18,
      medium: 16,
      small: 14,
      xSmall: 12,
      xMSmall: 11,
      xXSmall: 10,

      body: 17,
    },
    family: {
      regular: "'BlocketSans-Regular', sans-serif",
      bold: "'BlocketSans-Bold', sans-serif",
      medium: "'BlocketSans-Medium', sans-serif",
    },
    weight: {
      bold: 500,
    },
  },
  lineHeight: {
    parameter: 3.8,
    large: 2.5,
    medium: 1.6,
    small: 1.32,
  },
  frameWork: {
    contentMaxWidth: 980,
  },
  breakPoints: {
    small: 576,
    tabletUp: 768,
  },
  zIndex: {
    dropDownMenu: 1000,
  },
  width: {
    bigScreenMax: 1000,
  },
  boxShadow: '0 1px 0 0 #cdcccc',
  boxShadow2: '0 0 6px 0 rgba(54, 52, 51, 0.15)',
  border: {
    radius: {
      small: 2,
      medium: 4,
    },
  },
}

export default Immutable.from(styleguide)
